import React from "react";
import { connect } from "react-redux";

import Button from "@mui/material/Button";
import Pagination from '@mui/material/Pagination';
import {FormattedMessage} from "react-intl";
import {setGroheWizardStep} from "../../../../../actions/groheQuotingToolFunctions";

const GroheQuotingToolSteps = (props) => {

  const {subParts, totalSteps, wizardStep, setGroheWizardStep} = props;

  console.log("totalSteps", totalSteps);
  console.log("wizardStep", wizardStep);

  if(!subParts) {
    return null
  }

  const handleNext = () => {
    setGroheWizardStep(wizardStep + 1);
  };

  const handleBack = () => {
    setGroheWizardStep(wizardStep - 1);
  };

  const paginationButtonClick = (event, page) => {
    // console.log("event", event);
    console.log("page", page);

    setGroheWizardStep(page - 1);
  };

  return (
    <div className="grohe-section__description">
      <div className="grohe-stepper">
        <div className="grohe-stepper__buttons">
          <Button className="look-button look-button--secondary grohe-look__button grohe-stepper__buttons-button"
                  onClick={handleBack} disabled={wizardStep === 0} fullWidth={true}>
            <FormattedMessage id="grohe.wizard.button.previous"/>
          </Button>
          <Button className="look-button look-button--secondary grohe-look__button grohe-stepper__buttons-button"
                  onClick={handleNext} disabled={wizardStep === totalSteps - 1} fullWidth={true}>
            <FormattedMessage id="grohe.wizard.button.next"/>
          </Button>
        </div>
        <div className="grohe-stepper__dots">
          <Pagination count={totalSteps}
                      page={wizardStep + 1}
                      size="8"
                      boundaryCount={100}
                      color="primary"
                      hidePrevButton
                      hideNextButton
                      onChange={paginationButtonClick}/>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {wizardStep} = store.groheQuotingToolState;
  return {
    lookPageOpened,
    wizardStep,
  };
};

const mapDispatchToProps = {
  setGroheWizardStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheQuotingToolSteps)
